;(function() {
  const bbCollectionProductShows = document.querySelectorAll('.bb-collection-product-show')
  bbCollectionProductShows.forEach(this_ => {
    const menuItems = this_.querySelectorAll('.bb-collection-product-show-menu-item')
    const productLists = this_.querySelectorAll('.bb-collection-product-show-container')
    const productSwipers = this_.querySelectorAll('.bb-collection-product-show-list')

    initSwiper()
    if(!this_.getAttribute('init')) {
      init()
      this_.setAttribute('init', true)
    }
    window.addEventListener('resize', initSwiper)
    

    function initSwiper() {
      productSwipers.forEach(productSwiper => {
        new Swiper(productSwiper, {
          slidesPerView: window.innerWidth >= 960 ? 4 : 2.36,
          grid: {
              fill: 'row',
              rows: 1,
          },
          navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
          },
        })
      })
    }

    function init() {
      menuItems.forEach(item => {
        item.addEventListener('click', () => {
          menuItems.forEach((item_) => {
              item_.removeAttribute('active')
          })
          item.setAttribute('active', true)
          productLists.forEach((list) => {
              list.removeAttribute('active')
          })
          productLists.forEach((list) => {
              if (list.getAttribute('data-collection') === item.getAttribute('data-collection')) {
                  list.setAttribute('active', true)
              }
          })
        })
      })
    }
  })
})()